import { Link } from 'react-router-dom';

const COLUMNS = [
  {
    title: '栏目导航',
    links: [
      { label: '首页', to: '/' },
      { label: '全部漫画', to: '/category' },
      { label: '排行榜', to: '/ranking' },
      { label: '关于我们', to: '/about' },
    ],
  },
  {
    title: '热门题材',
    links: [
      { label: '古风恋爱', to: '/category?g=古风' },
      { label: '现代言情', to: '/category?g=现代言情' },
      { label: '甜宠漫画', to: '/category?g=甜宠' },
      { label: '校园青春', to: '/category?g=校园' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-flower-fill text-lg" />
              </span>
              <span className="font-display text-2xl font-bold text-primary-600">桃花漫画网</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-7 text-foreground-600">
              桃花漫画网是专注于恋爱、言情与少女漫画的在线阅读平台。古风恋爱、现代言情、甜宠少女漫画分类齐全，热门作品实时更新，免费章节丰富，让每一位喜欢看漫画的你都能轻松追更。
            </p>
            <div className="mt-5 flex items-center gap-3 text-foreground-500">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-50 text-sm">
                <i className="ri-mail-line" />
              </span>
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-50 text-sm">
                <i className="ri-question-line" />
              </span>
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-50 text-sm">
                <i className="ri-heart-3-line" />
              </span>
            </div>
          </div>

          {COLUMNS.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-bold text-foreground-800">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-500"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">© 2026 桃花漫画网 · 恋爱漫画在线阅读 · 追更不迷路</p>
          <p className="text-xs text-foreground-400">本站内容仅供学习交流，请支持正版漫画</p>
        </div>
      </div>
    </footer>
  );
}